export default "__VITE_ASSET__835866ed__"